import React, { useState, useEffect } from 'react';
import { makeStyles, createStyles } from '@material-ui/core/styles';
import { Dialog, DialogTitle, DialogContent } from '@material-ui/core';
import { DialogAction } from '../../../function/useModal';
import { useTranslation } from 'react-i18next';
import TrendSettingPage from '../../Pages/GroupSettings/TrendSetting/TrendSettingPage';
import { SettingsState } from '../../organisms/SelectSettings';

type TrendSettingDialogProps = {
  dialog: DialogAction<TrendSettingDialogResponse>;
  groupNo: number;
};

export type TrendSettingDialogResponse = {};

const useStyles = makeStyles(
  createStyles({
    dialog: {
      background: '#FFFFEE',
    },
  })
);

const TrendSettingDialog: React.FC<TrendSettingDialogProps> = (props: TrendSettingDialogProps) => {
  const { t } = useTranslation();
  const classes = useStyles();
  const [isOpen, setIsOpen] = useState<boolean>(true);
  const [mode, setMode] = useState<boolean>(true);
  const [no, setNo] = useState<number>(props.groupNo);
  const [editData, setEditData] = useState<SettingsState>(new SettingsState());
  const [dummyIdx, setDummyIdx] = useState<number>(0);

  useEffect(() => {
    //console.debug('-- useEffect editData --', editData)
    editData.DispatchIndex = setDummyIdx;
  }, [editData]);

  useEffect(() => {
    //console.debug(['-- useEffect dummyIdx --', editData.IsUpdate, dummyIdx])
    if (dummyIdx < 0) {
      setIsOpen(false);
      setMode(editData.IsSaveClose);
    }
  }, [dummyIdx]);

  return (
    <>
      <Dialog
        open={isOpen}
        fullScreen={false}
        maxWidth={'xl'}
        onEntered={(e) => {}}
        onExited={(e) => {
          if (mode) {
            props.dialog.apply({});
          } else {
            props.dialog.cancel();
          }
        }}
        PaperProps={{ className: classes.dialog }}
      >
        <DialogTitle>{t('TrendSettingDialog.傾向管理グループ設定', '傾向管理グループ設定')}</DialogTitle>
        <DialogContent>
          <TrendSettingPage editData={editData} groupNo={props.groupNo} isDialog={true} />
        </DialogContent>
      </Dialog>
    </>
  );
};

export default TrendSettingDialog;

//import TrendSettingDialog, { TrendSettingDialogResponse } from '../../molecules/Dialog/TrendSettingDialog';
//const [flgTSDlg, actTSDlg] = useModal<TrendSettingDialogResponse>();
// const tsdlg = flgTSDlg ? <TrendSettingDialog dialog={actTSDlg} groupNo={1} /> : null;
